import { useMemo } from 'react'
import debounce from 'lodash.debounce'

const _useDebounce = (callback, delay) => useMemo(() => debounce((...args) => callback(...args), delay),
  [delay])

export default _useDebounce
